import React from 'react';
import { useParams } from 'react-router-dom';
import { Auth } from 'connex-cds';
import { useMenuConfig } from '../../menu-config';
const { IFrameAuthenticated } = Auth;

const AuthenticatedRoutes = () => {
  const { entityRef } = useParams();
  const menuConfig = useMenuConfig();

  return <IFrameAuthenticated entityRef={entityRef} menuConfig={menuConfig} />;
};

export default AuthenticatedRoutes;
